export default __webpack_public_path__ + "static/media/usability.61d87d3a.jpg";